import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../support/with_presenter';
import {TrainingPlanSelectorWithInitialDataPresenter} from './TrainingPlanSelectorWithInitialDataPresenter';
import {TrainingPlanSelector} from './TrainingPlanSelector';
import {TrainingPlan} from '../models/TrainingPlan';

interface OwnProps {
    intiallySelectedTrainingPlanIds: number[];
}

const TrainingPlanSelectorWithInitialDataComponent: FunctionComponent<
    OwnProps & PresenterProps<TrainingPlanSelectorWithInitialDataPresenter>
> = observer(({intiallySelectedTrainingPlanIds, presenter}) => {
    if (presenter.initialTrainingPlans !== null) {
        return <TrainingPlanSelector trainingPlans={presenter.initialTrainingPlans} />;
    }

    if (intiallySelectedTrainingPlanIds.length < 2) {
        return (
            <div className="training-plan-element-selector__empty">
                <div />
                <div />
                <div />
            </div>
        );
    }
    return (
        <div className="training-plan-element-selector__empty">
            {intiallySelectedTrainingPlanIds.map((_, index) => (
                <div key={index} />
            ))}
        </div>
    );
});

export const TrainingPlanSelectorWithInitialData = withPresenter<
    TrainingPlanSelectorWithInitialDataPresenter,
    OwnProps
>(
    (props, component) =>
        new TrainingPlanSelectorWithInitialDataPresenter(
            props.intiallySelectedTrainingPlanIds,
            component.trainingPlanProvider,
        ),
    TrainingPlanSelectorWithInitialDataComponent,
);
